import React from "react";
import './index.css'

interface addNewRentalPageProps{
    className?:string
}

export const AddNewRentalPage:React.FC<addNewRentalPageProps> = ({className})=>{
    return(
        <div className={`${className}`}>
            <h3>Add new Rental Page </h3>
        </div>
    )
}